// Labeled native <select> for admin list filters, on the shared Field wiring.

import { Field, Select } from "@/ui";

export interface FilterOption {
  value: string;
  label: string;
}

export function FilterSelect({
  label,
  value,
  options,
  onChange,
  size = "md",
}: {
  label: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
  size?: "sm" | "md";
}) {
  const id = `filter-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  return (
    <Field label={label} id={id}>
      {(control) => (
        <Select {...control} size={size} value={value} onChange={(e) => onChange(e.target.value)}>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </Select>
      )}
    </Field>
  );
}
